export default __webpack_public_path__ + "static/media/logo138x75white.a55532c9.png";